module.exports = __webpack_public_path__ + "img/hand-holding-skull.65bc87d8.svg";